import { Provider } from '@angular/core';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { translation } from '../i18n/translation.constant';

export function providePersonalDetailsI18n(): Provider {
  return [provideTranslationDictionaryMapping(translation)];
}
